var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.plp_task_id)?_c('VersionSelect',{attrs:{"fluid":""},scopedSlots:_vm._u([{key:"content",fn:function({ data, readonly, onChange, onBlur, onCreate }){return [_c('ExpertiseKEITabs',{attrs:{"value":data,"readonly":readonly,"onCreate":onCreate,"dictType":_vm.dict},on:{"change":onChange,"blur":onBlur}})]}}],null,false,3630952993)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }